/*
 * Layout for the basic KB settings
 */

define(["marionette", "messaging/messenger", "./template/kbSettingsTemplate.html"], function (
  Marionette,
  Messenger,
  KbSettingsTemplate,
) {
  "use strict";

  return {
    kbSettingsLayout: Marionette.Layout.extend({
      template: KbSettingsTemplate,
      triggers: {
        "click #togglePcasPassword": "togglePcasPassword",
        "click #toggleSecretKey": "toggleSecretKey",
        "click #editSettings": "editSettings",
        "click #editAgentAssist": "editAgentAssist",
        "click #removeKb": "removeKb",
      },
      templateHelpers: {
        getEngineModeLabel: function (modeValue) {
          return Messenger.reqres.request("kb:engine:mode:label", modeValue);
        },
      },
    }),
  };
});
